import "./Featured.scss"
import FeaturedCard from "./FeaturedCard"
import { useTranslation } from 'react-i18next'
import { useScrollReveal } from "../../../utils/useScrollReveal"


const Featured = () => {
  const { t } = useTranslation('services')
  const { ref, visible } = useScrollReveal<HTMLElement>()
  return (
    <>
      <section className={`featured background reveal${visible ? ' visible' : ''}`} ref={ref}>
        <div className='container'>
          <div className='section-header'>
            <span className='section-label section-label--light'>{t('Services')}</span>
            <h2 className='light'>{t('Our services')}</h2>
            <p className='intro light'>{t('Discover all the pleasures Le Corvier has to offer.')}</p>
          </div>
          <FeaturedCard />
        </div>
      </section>
    </>
  )
}

export default Featured
